import React from 'react';
import { AlertCircleIcon } from 'lucide-react';
interface FieldProps {
  label: string;
  htmlFor?: string;
  hint?: string;
  error?: string;
  children: React.ReactNode;
  className?: string;
}
export function Field({
  label,
  htmlFor,
  hint,
  error,
  children,
  className = ''
}: FieldProps) {
  return <div className={className} data-id="element-433" data-mp="43eph54gpe5h">
      <label htmlFor={htmlFor} className="block text-[13px] font-medium text-ink" data-id="element-434" data-mp="43oil1kt01fe">
        {label}
      </label>
      {hint && <p className="mt-0.5 text-xs text-ink-soft" data-id="element-435" data-mp="d2jn898793gl">{hint}</p>}
      <div className="mt-1.5" data-id="element-436" data-mp="d0yt2kpsrmj9">{children}</div>
      {error && <p className="mt-1.5 flex items-center gap-1.5 text-xs text-critical-ink" data-id="element-437" data-mp="hutcdn1hpzht">
          <AlertCircleIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-438" data-mp="mt4k9s885zxe" />
          {error}
        </p>}
    </div>;
}